import CellBuilder from "components/cell-builder/CellBuilder";
import ElipsisMenu, { MenuItem } from "components/elipsis-menu/ElipsisMenu";

const expandedEntryColumn = [
  {
    selector: (row) => CellBuilder(row.commodity),
    grow: 2,
    style: { marginLeft: "46px" },
  },
  {
    selector: (row) => CellBuilder(row.tonnage),
    grow: 1,
  },
  {
    selector: (row) => CellBuilder(row.truck),
    grow: 1,
  },
  {
    selector: (row) => CellBuilder(row.rail),
    grow: 1,
  },
  {
    selector: (row) => CellBuilder(row.air),
    grow: 1,
  },
  {
    selector: (row) => CellBuilder(row.origin),
    grow: 2,
  },
  {
    selector: (row) => CellBuilder(row.destination),
    grow: 2,
  },
  // {
  //   selector: (row) => CellBuilder(row.delivered),
  //   grow: 1,
  // },
  // {
  //   name: "Actions",
  //   selector: () => (
  //     <div className="table-actions">
  //       <ElipsisMenu>
  //         <MenuItem title="Edit" />
  //         <MenuItem title="Delete" />
  //       </ElipsisMenu>
  //     </div>
  //   ),
  //   grow: 1,
  // },
];
export default expandedEntryColumn;
